// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3416":"047ab03e","7154":"d020a249"}[chunkId] + ".chunk.css";
};